<template>
<edit-form
        v-bind:data-url="actualUrls.formUrl"
        v-bind:save-url="actualUrls.storeUrl"
        v-bind:ajax-operations-url="actualUrls.formAjaxOperationsUrl"
        v-on:submit-success="closeOnSuccess"
        v-on:editing-canceled="$emit('close')"
        redirect-to-response-on-success="false"
        :buttons="formButtons"
        :show-header="!subject"
></edit-form>
</template>

<script>
    export default {
        inject: ['loadingIndicator', 'getCSSClass', 'translate', 'icon'],
        props: {
            urls: {type: Object},
            subject: {},
            currentPath: {},
        },
        provide: function() {
            return {
                mainButtons: this.formButtons
            }
        },
        data: function () {
            return {
                formButtons: {
                    'save_and_close': {'class': 'btn-outline-primary', 'html': this.translate('Mentés')},
                    'cancel': {'class': 'btn-outline-secondary', 'html': this.translate('Mégse')},
                }
            }
        },
        mounted() {
        },
        methods: {
            closeOnSuccess: function() {
                this.$emit('saved', {});
                this.$emit('close');
            }
        },
        computed: {
            actualUrls: function()  {
                let result = {};
                Object.keys(this.urls).forEach((key) => {
                    let url = new URL(this.subject && this.subject['id'] ? this.urls[key].replace('___id___', this.subject['id']) : this.urls[key]);
                    if (this.currentPath.length > 1) {
                        url.searchParams.set('folderId', this.currentPath[this.currentPath.length - 1].id);
                    }
                    result[key] = url.toString();
                });

                return result;
            }
        },
        watch: {}

    }
</script>
